module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2016-04-18",
		"endpointPrefix": "cognito-idp",
		"jsonVersion": "1.1",
		"protocol": "json",
		"serviceFullName": "Amazon Cognito Identity Provider",
		"serviceId": "Cognito Identity Provider",
		"signatureVersion": "v4",
		"targetPrefix": "AWSCognitoIdentityProviderService",
		"uid": "cognito-idp-2016-04-18"
	},
	"operations": {
		"AddCustomAttributes": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"CustomAttributes"
				],
				"members": {
					"UserPoolId": {},
					"CustomAttributes": {
						"type": "list",
						"member": {
							"shape": "S4"
						}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"AdminAddUserToGroup": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Username",
					"GroupName"
				],
				"members": {
					"UserPoolId": {},
					"Username": {
						"shape": "Sd"
					},
					"GroupName": {}
				}
			}
		},
		"AdminConfirmSignUp": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Username"
				],
				"members": {
					"UserPoolId": {},
					"Username": {
						"shape": "Sd"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"AdminCreateUser": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Username"
				],
				"members": {
					"UserPoolId": {},
					"Username": {
						"shape": "Sd"
					},
					"UserAttributes": {
						"shape": "Si"
					},
					"ValidationData": {
						"shape": "Si"
					},
					"TemporaryPassword": {
						"shape": "Sm"
					},
					"ForceAliasCreation": {
						"type": "boolean"
					},
					"MessageAction": {},
					"DesiredDeliveryMediums": {
						"type": "list",
						"member": {}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"User": {
						"shape": "Ss"
					}
				}
			}
		},
		"AdminDeleteUser": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Username"
				],
				"members": {
					"UserPoolId": {},
					"Username": {
						"shape": "Sd"
					}
				}
			}
		},
		"AdminDeleteUserAttributes": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Username",
					"UserAttributeNames"
				],
				"members": {
					"UserPoolId": {},
					"Username": {
						"shape": "Sd"
					},
					"UserAttributeNames": {
						"shape": "Sz"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"AdminDisableProviderForUser": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"User"
				],
				"members": {
					"UserPoolId": {},
					"User": {
						"shape": "S12"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"AdminDisableUser": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Username"
				],
				"members": {
					"UserPoolId": {},
					"Username": {
						"shape": "Sd"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"AdminEnableUser": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Username"
				],
				"members": {
					"UserPoolId": {},
					"Username": {
						"shape": "Sd"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"AdminForgetDevice": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Username",
					"DeviceKey"
				],
				"members": {
					"UserPoolId": {},
					"Username": {
						"shape": "Sd"
					},
					"DeviceKey": {}
				}
			}
		},
		"AdminGetDevice": {
			"input": {
				"type": "structure",
				"required": [
					"DeviceKey",
					"UserPoolId",
					"Username"
				],
				"members": {
					"DeviceKey": {},
					"UserPoolId": {},
					"Username": {
						"shape": "Sd"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"Device"
				],
				"members": {
					"Device": {
						"shape": "S1d"
					}
				}
			}
		},
		"AdminGetUser": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Username"
				],
				"members": {
					"UserPoolId": {},
					"Username": {
						"shape": "Sd"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"Username"
				],
				"members": {
					"Username": {
						"shape": "Sd"
					},
					"UserAttributes": {
						"shape": "Si"
					},
					"UserCreateDate": {
						"type": "timestamp"
					},
					"UserLastModifiedDate": {
						"type": "timestamp"
					},
					"Enabled": {
						"type": "boolean"
					},
					"UserStatus": {},
					"MFAOptions": {
						"shape": "Sv"
					},
					"PreferredMfaSetting": {},
					"UserMFASettingList": {
						"shape": "S1g"
					}
				}
			}
		},
		"AdminInitiateAuth": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"ClientId",
					"AuthFlow"
				],
				"members": {
					"UserPoolId": {},
					"ClientId": {
						"shape": "S1i"
					},
					"AuthFlow": {},
					"AuthParameters": {
						"shape": "S1k"
					},
					"ClientMetadata": {
						"shape": "S1l"
					},
					"AnalyticsMetadata": {
						"shape": "S1m"
					},
					"ContextData": {
						"shape": "S1n"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ChallengeName": {},
					"Session": {},
					"ChallengeParameters": {
						"shape": "S1t"
					},
					"AuthenticationResult": {
						"shape": "S1u"
					}
				}
			}
		},
		"AdminLinkProviderForUser": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"DestinationUser",
					"SourceUser"
				],
				"members": {
					"UserPoolId": {},
					"DestinationUser": {
						"shape": "S12"
					},
					"SourceUser": {
						"shape": "S12"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"AdminListDevices": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Username"
				],
				"members": {
					"UserPoolId": {},
					"Username": {
						"shape": "Sd"
					},
					"Limit": {
						"type": "integer"
					},
					"PaginationToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Devices": {
						"shape": "S24"
					},
					"PaginationToken": {}
				}
			}
		},
		"AdminListGroupsForUser": {
			"input": {
				"type": "structure",
				"required": [
					"Username",
					"UserPoolId"
				],
				"members": {
					"Username": {
						"shape": "Sd"
					},
					"UserPoolId": {},
					"Limit": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Groups": {
						"shape": "S28"
					},
					"NextToken": {}
				}
			}
		},
		"AdminListUserAuthEvents": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Username"
				],
				"members": {
					"UserPoolId": {},
					"Username": {
						"shape": "Sd"
					},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"AuthEvents": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"EventId": {},
								"EventType": {},
								"CreationDate": {
									"type": "timestamp"
								},
								"EventResponse": {},
								"EventRisk": {
									"type": "structure",
									"members": {
										"RiskDecision": {},
										"RiskLevel": {}
									}
								},
								"ChallengeResponses": {
									"type": "list",
									"member": {
										"type": "structure",
										"members": {
											"ChallengeName": {},
											"ChallengeResponse": {}
										}
									}
								},
								"EventContextData": {
									"type": "structure",
									"members": {
										"IpAddress": {},
										"DeviceName": {},
										"Timezone": {},
										"City": {},
										"Country": {}
									}
								},
								"EventFeedback": {
									"type": "structure",
									"required": [
										"FeedbackValue",
										"Provider"
									],
									"members": {
										"FeedbackValue": {},
										"Provider": {},
										"FeedbackDate": {
											"type": "timestamp"
										}
									}
								}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"AdminRemoveUserFromGroup": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Username",
					"GroupName"
				],
				"members": {
					"UserPoolId": {},
					"Username": {
						"shape": "Sd"
					},
					"GroupName": {}
				}
			}
		},
		"AdminResetUserPassword": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Username"
				],
				"members": {
					"UserPoolId": {},
					"Username": {
						"shape": "Sd"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"AdminRespondToAuthChallenge": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"ClientId",
					"ChallengeName"
				],
				"members": {
					"UserPoolId": {},
					"ClientId": {
						"shape": "S1i"
					},
					"ChallengeName": {},
					"ChallengeResponses": {
						"shape": "S2x"
					},
					"Session": {},
					"AnalyticsMetadata": {
						"shape": "S1m"
					},
					"ContextData": {
						"shape": "S1n"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ChallengeName": {},
					"Session": {},
					"ChallengeParameters": {
						"shape": "S1t"
					},
					"AuthenticationResult": {
						"shape": "S1u"
					}
				}
			}
		},
		"AdminSetUserMFAPreference": {
			"input": {
				"type": "structure",
				"required": [
					"Username",
					"UserPoolId"
				],
				"members": {
					"SMSMfaSettings": {
						"shape": "S30"
					},
					"SoftwareTokenMfaSettings": {
						"shape": "S31"
					},
					"Username": {
						"shape": "Sd"
					},
					"UserPoolId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"AdminSetUserSettings": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Username",
					"MFAOptions"
				],
				"members": {
					"UserPoolId": {},
					"Username": {
						"shape": "Sd"
					},
					"MFAOptions": {
						"shape": "Sv"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"AdminUpdateAuthEventFeedback": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Username",
					"EventId",
					"FeedbackValue"
				],
				"members": {
					"UserPoolId": {},
					"Username": {
						"shape": "Sd"
					},
					"EventId": {},
					"FeedbackValue": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"AdminUpdateDeviceStatus": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Username",
					"DeviceKey"
				],
				"members": {
					"UserPoolId": {},
					"Username": {
						"shape": "Sd"
					},
					"DeviceKey": {},
					"DeviceRememberedStatus": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"AdminUpdateUserAttributes": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Username",
					"UserAttributes"
				],
				"members": {
					"UserPoolId": {},
					"Username": {
						"shape": "Sd"
					},
					"UserAttributes": {
						"shape": "Si"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"AdminUserGlobalSignOut": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Username"
				],
				"members": {
					"UserPoolId": {},
					"Username": {
						"shape": "Sd"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"AssociateSoftwareToken": {
			"input": {
				"type": "structure",
				"members": {
					"AccessToken": {
						"shape": "S1v"
					},
					"Session": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"SecretCode": {
						"type": "string",
						"sensitive": true
					},
					"Session": {}
				}
			}
		},
		"ChangePassword": {
			"input": {
				"type": "structure",
				"required": [
					"PreviousPassword",
					"ProposedPassword",
					"AccessToken"
				],
				"members": {
					"PreviousPassword": {
						"shape": "Sm"
					},
					"ProposedPassword": {
						"shape": "Sm"
					},
					"AccessToken": {
						"shape": "S1v"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			},
			"authtype": "none"
		},
		"ConfirmDevice": {
			"input": {
				"type": "structure",
				"required": [
					"AccessToken",
					"DeviceKey"
				],
				"members": {
					"AccessToken": {
						"shape": "S1v"
					},
					"DeviceKey": {},
					"DeviceSecretVerifierConfig": {
						"type": "structure",
						"members": {
							"PasswordVerifier": {},
							"Salt": {}
						}
					},
					"DeviceName": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"UserConfirmationNecessary": {
						"type": "boolean"
					}
				}
			}
		},
		"ConfirmForgotPassword": {
			"input": {
				"type": "structure",
				"required": [
					"ClientId",
					"Username",
					"ConfirmationCode",
					"Password"
				],
				"members": {
					"ClientId": {
						"shape": "S1i"
					},
					"SecretHash": {
						"shape": "S3p"
					},
					"Username": {
						"shape": "Sd"
					},
					"ConfirmationCode": {},
					"Password": {
						"shape": "Sm"
					},
					"AnalyticsMetadata": {
						"shape": "S1m"
					},
					"UserContextData": {
						"shape": "S3r"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			},
			"authtype": "none"
		},
		"ConfirmSignUp": {
			"input": {
				"type": "structure",
				"required": [
					"ClientId",
					"Username",
					"ConfirmationCode"
				],
				"members": {
					"ClientId": {
						"shape": "S1i"
					},
					"SecretHash": {
						"shape": "S3p"
					},
					"Username": {
						"shape": "Sd"
					},
					"ConfirmationCode": {},
					"ForceAliasCreation": {
						"type": "boolean"
					},
					"AnalyticsMetadata": {
						"shape": "S1m"
					},
					"UserContextData": {
						"shape": "S3r"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			},
			"authtype": "none"
		},
		"CreateGroup": {
			"input": {
				"type": "structure",
				"required": [
					"GroupName",
					"UserPoolId"
				],
				"members": {
					"GroupName": {},
					"UserPoolId": {},
					"Description": {},
					"RoleArn": {},
					"Precedence": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Group": {
						"shape": "S29"
					}
				}
			}
		},
		"CreateIdentityProvider": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"ProviderName",
					"ProviderType",
					"ProviderDetails"
				],
				"members": {
					"UserPoolId": {},
					"ProviderName": {},
					"ProviderType": {},
					"ProviderDetails": {
						"shape": "S40"
					},
					"AttributeMapping": {
						"shape": "S41"
					},
					"IdpIdentifiers": {
						"shape": "S43"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"IdentityProvider"
				],
				"members": {
					"IdentityProvider": {
						"shape": "S46"
					}
				}
			}
		},
		"CreateResourceServer": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Identifier",
					"Name"
				],
				"members": {
					"UserPoolId": {},
					"Identifier": {},
					"Name": {},
					"Scopes": {
						"shape": "S4a"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"ResourceServer"
				],
				"members": {
					"ResourceServer": {
						"shape": "S4f"
					}
				}
			}
		},
		"CreateUserImportJob": {
			"input": {
				"type": "structure",
				"required": [
					"JobName",
					"UserPoolId",
					"CloudWatchLogsRoleArn"
				],
				"members": {
					"JobName": {},
					"UserPoolId": {},
					"CloudWatchLogsRoleArn": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"UserImportJob": {
						"shape": "S4j"
					}
				}
			}
		},
		"CreateUserPool": {
			"input": {
				"type": "structure",
				"required": [
					"PoolName"
				],
				"members": {
					"PoolName": {},
					"Policies": {
						"shape": "S4r"
					},
					"LambdaConfig": {
						"shape": "S4u"
					},
					"AutoVerifiedAttributes": {
						"shape": "S4v"
					},
					"AliasAttributes": {
						"shape": "S4x"
					},
					"UsernameAttributes": {
						"shape": "S4z"
					},
					"SmsVerificationMessage": {},
					"EmailVerificationMessage": {},
					"EmailVerificationSubject": {},
					"VerificationMessageTemplate": {
						"shape": "S54"
					},
					"SmsAuthenticationMessage": {},
					"MfaConfiguration": {},
					"DeviceConfiguration": {
						"shape": "S59"
					},
					"EmailConfiguration": {
						"shape": "S5a"
					},
					"SmsConfiguration": {
						"shape": "S5c"
					},
					"UserPoolTags": {
						"shape": "S5d"
					},
					"AdminCreateUserConfig": {
						"shape": "S5e"
					},
					"Schema": {
						"shape": "S5h"
					},
					"UserPoolAddOns": {
						"shape": "S5i"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"UserPool": {
						"shape": "S5l"
					}
				}
			}
		},
		"CreateUserPoolClient": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"ClientName"
				],
				"members": {
					"UserPoolId": {},
					"ClientName": {},
					"GenerateSecret": {
						"type": "boolean"
					},
					"RefreshTokenValidity": {
						"type": "integer"
					},
					"ReadAttributes": {
						"shape": "S5s"
					},
					"WriteAttributes": {
						"shape": "S5s"
					},
					"ExplicitAuthFlows": {
						"shape": "S5u"
					},
					"SupportedIdentityProviders": {
						"shape": "S5w"
					},
					"CallbackURLs": {
						"shape": "S5x"
					},
					"LogoutURLs": {
						"shape": "S5z"
					},
					"DefaultRedirectURI": {},
					"AllowedOAuthFlows": {
						"shape": "S60"
					},
					"AllowedOAuthScopes": {
						"shape": "S62"
					},
					"AllowedOAuthFlowsUserPoolClient": {
						"type": "boolean"
					},
					"AnalyticsConfiguration": {
						"shape": "S64"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"UserPoolClient": {
						"shape": "S67"
					}
				}
			}
		},
		"CreateUserPoolDomain": {
			"input": {
				"type": "structure",
				"required": [
					"Domain",
					"UserPoolId"
				],
				"members": {
					"Domain": {},
					"UserPoolId": {},
					"CustomDomainConfig": {
						"shape": "S6a"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"CloudFrontDomain": {}
				}
			}
		},
		"DeleteGroup": {
			"input": {
				"type": "structure",
				"required": [
					"GroupName",
					"UserPoolId"
				],
				"members": {
					"GroupName": {},
					"UserPoolId": {}
				}
			}
		},
		"DeleteIdentityProvider": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"ProviderName"
				],
				"members": {
					"UserPoolId": {},
					"ProviderName": {}
				}
			}
		},
		"DeleteResourceServer": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Identifier"
				],
				"members": {
					"UserPoolId": {},
					"Identifier": {}
				}
			}
		},
		"DeleteUser": {
			"input": {
				"type": "structure",
				"required": [
					"AccessToken"
				],
				"members": {
					"AccessToken": {
						"shape": "S1v"
					}
				}
			},
			"authtype": "none"
		},
		"DeleteUserAttributes": {
			"input": {
				"type": "structure",
				"required": [
					"UserAttributeNames",
					"AccessToken"
				],
				"members": {
					"UserAttributeNames": {
						"shape": "Sz"
					},
					"AccessToken": {
						"shape": "S1v"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			},
			"authtype": "none"
		},
		"DeleteUserPool": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId"
				],
				"members": {
					"UserPoolId": {}
				}
			}
		},
		"DeleteUserPoolClient": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"ClientId"
				],
				"members": {
					"UserPoolId": {},
					"ClientId": {
						"shape": "S1i"
					}
				}
			}
		},
		"DeleteUserPoolDomain": {
			"input": {
				"type": "structure",
				"required": [
					"Domain",
					"UserPoolId"
				],
				"members": {
					"Domain": {},
					"UserPoolId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"DescribeIdentityProvider": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"ProviderName"
				],
				"members": {
					"UserPoolId": {},
					"ProviderName": {}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"IdentityProvider"
				],
				"members": {
					"IdentityProvider": {
						"shape": "S46"
					}
				}
			}
		},
		"DescribeResourceServer": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Identifier"
				],
				"members": {
					"UserPoolId": {},
					"Identifier": {}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"ResourceServer"
				],
				"members": {
					"ResourceServer": {
						"shape": "S4f"
					}
				}
			}
		},
		"DescribeRiskConfiguration": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId"
				],
				"members": {
					"UserPoolId": {},
					"ClientId": {
						"shape": "S1i"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"RiskConfiguration"
				],
				"members": {
					"RiskConfiguration": {
						"shape": "S6s"
					}
				}
			}
		},
		"DescribeUserImportJob": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"JobId"
				],
				"members": {
					"UserPoolId": {},
					"JobId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"UserImportJob": {
						"shape": "S4j"
					}
				}
			}
		},
		"DescribeUserPool": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId"
				],
				"members": {
					"UserPoolId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"UserPool": {
						"shape": "S5l"
					}
				}
			}
		},
		"DescribeUserPoolClient": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"ClientId"
				],
				"members": {
					"UserPoolId": {},
					"ClientId": {
						"shape": "S1i"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"UserPoolClient": {
						"shape": "S67"
					}
				}
			}
		},
		"DescribeUserPoolDomain": {
			"input": {
				"type": "structure",
				"required": [
					"Domain"
				],
				"members": {
					"Domain": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"DomainDescription": {
						"type": "structure",
						"members": {
							"UserPoolId": {},
							"AWSAccountId": {},
							"Domain": {},
							"S3Bucket": {},
							"CloudFrontDistribution": {},
							"Version": {},
							"Status": {},
							"CustomDomainConfig": {
								"shape": "S6a"
							}
						}
					}
				}
			}
		},
		"ForgetDevice": {
			"input": {
				"type": "structure",
				"required": [
					"DeviceKey"
				],
				"members": {
					"AccessToken": {
						"shape": "S1v"
					},
					"DeviceKey": {}
				}
			}
		},
		"ForgotPassword": {
			"input": {
				"type": "structure",
				"required": [
					"ClientId",
					"Username"
				],
				"members": {
					"ClientId": {
						"shape": "S1i"
					},
					"SecretHash": {
						"shape": "S3p"
					},
					"UserContextData": {
						"shape": "S3r"
					},
					"Username": {
						"shape": "Sd"
					},
					"AnalyticsMetadata": {
						"shape": "S1m"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"CodeDeliveryDetails": {
						"shape": "S7q"
					}
				}
			},
			"authtype": "none"
		},
		"GetCSVHeader": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId"
				],
				"members": {
					"UserPoolId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"UserPoolId": {},
					"CSVHeader": {
						"type": "list",
						"member": {}
					}
				}
			}
		},
		"GetDevice": {
			"input": {
				"type": "structure",
				"required": [
					"DeviceKey"
				],
				"members": {
					"DeviceKey": {},
					"AccessToken": {
						"shape": "S1v"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"Device"
				],
				"members": {
					"Device": {
						"shape": "S1d"
					}
				}
			}
		},
		"GetGroup": {
			"input": {
				"type": "structure",
				"required": [
					"GroupName",
					"UserPoolId"
				],
				"members": {
					"GroupName": {},
					"UserPoolId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Group": {
						"shape": "S29"
					}
				}
			}
		},
		"GetIdentityProviderByIdentifier": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"IdpIdentifier"
				],
				"members": {
					"UserPoolId": {},
					"IdpIdentifier": {}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"IdentityProvider"
				],
				"members": {
					"IdentityProvider": {
						"shape": "S46"
					}
				}
			}
		},
		"GetSigningCertificate": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId"
				],
				"members": {
					"UserPoolId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Certificate": {}
				}
			}
		},
		"GetUICustomization": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId"
				],
				"members": {
					"UserPoolId": {},
					"ClientId": {
						"shape": "S1i"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"UICustomization"
				],
				"members": {
					"UICustomization": {
						"shape": "S84"
					}
				}
			}
		},
		"GetUser": {
			"input": {
				"type": "structure",
				"required": [
					"AccessToken"
				],
				"members": {
					"AccessToken": {
						"shape": "S1v"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"Username",
					"UserAttributes"
				],
				"members": {
					"Username": {
						"shape": "Sd"
					},
					"UserAttributes": {
						"shape": "Si"
					},
					"MFAOptions": {
						"shape": "Sv"
					},
					"PreferredMfaSetting": {},
					"UserMFASettingList": {
						"shape": "S1g"
					}
				}
			},
			"authtype": "none"
		},
		"GetUserAttributeVerificationCode": {
			"input": {
				"type": "structure",
				"required": [
					"AccessToken",
					"AttributeName"
				],
				"members": {
					"AccessToken": {
						"shape": "S1v"
					},
					"AttributeName": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"CodeDeliveryDetails": {
						"shape": "S7q"
					}
				}
			},
			"authtype": "none"
		},
		"GetUserPoolMfaConfig": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId"
				],
				"members": {
					"UserPoolId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"SmsMfaConfiguration": {
						"shape": "S8e"
					},
					"SoftwareTokenMfaConfiguration": {
						"shape": "S8f"
					},
					"MfaConfiguration": {}
				}
			}
		},
		"GlobalSignOut": {
			"input": {
				"type": "structure",
				"required": [
					"AccessToken"
				],
				"members": {
					"AccessToken": {
						"shape": "S1v"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"InitiateAuth": {
			"input": {
				"type": "structure",
				"required": [
					"AuthFlow",
					"ClientId"
				],
				"members": {
					"AuthFlow": {},
					"AuthParameters": {
						"shape": "S1k"
					},
					"ClientMetadata": {
						"shape": "S1l"
					},
					"ClientId": {
						"shape": "S1i"
					},
					"AnalyticsMetadata": {
						"shape": "S1m"
					},
					"UserContextData": {
						"shape": "S3r"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ChallengeName": {},
					"Session": {},
					"ChallengeParameters": {
						"shape": "S1t"
					},
					"AuthenticationResult": {
						"shape": "S1u"
					}
				}
			}
		},
		"ListDevices": {
			"input": {
				"type": "structure",
				"required": [
					"AccessToken"
				],
				"members": {
					"AccessToken": {
						"shape": "S1v"
					},
					"Limit": {
						"type": "integer"
					},
					"PaginationToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Devices": {
						"shape": "S24"
					},
					"PaginationToken": {}
				}
			}
		},
		"ListGroups": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId"
				],
				"members": {
					"UserPoolId": {},
					"Limit": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Groups": {
						"shape": "S28"
					},
					"NextToken": {}
				}
			}
		},
		"ListIdentityProviders": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId"
				],
				"members": {
					"UserPoolId": {},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"Providers"
				],
				"members": {
					"Providers": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"ProviderName": {},
								"ProviderType": {},
								"LastModifiedDate": {
									"type": "timestamp"
								},
								"CreationDate": {
									"type": "timestamp"
								}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"ListResourceServers": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId"
				],
				"members": {
					"UserPoolId": {},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"ResourceServers"
				],
				"members": {
					"ResourceServers": {
						"type": "list",
						"member": {
							"shape": "S4f"
						}
					},
					"NextToken": {}
				}
			}
		},
		"ListUserImportJobs": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"MaxResults"
				],
				"members": {
					"UserPoolId": {},
					"MaxResults": {
						"type": "integer"
					},
					"PaginationToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"UserImportJobs": {
						"type": "list",
						"member": {
							"shape": "S4j"
						}
					},
					"PaginationToken": {}
				}
			}
		},
		"ListUserPoolClients": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId"
				],
				"members": {
					"UserPoolId": {},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"UserPoolClients": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"ClientId": {
									"shape": "S1i"
								},
								"UserPoolId": {},
								"ClientName": {}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"ListUserPools": {
			"input": {
				"type": "structure",
				"required": [
					"MaxResults"
				],
				"members": {
					"NextToken": {},
					"MaxResults": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"UserPools": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Id": {},
								"Name": {},
								"LambdaConfig": {
									"shape": "S4u"
								},
								"Status": {},
								"LastModifiedDate": {
									"type": "timestamp"
								},
								"CreationDate": {
									"type": "timestamp"
								}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"ListUsers": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId"
				],
				"members": {
					"UserPoolId": {},
					"AttributesToGet": {
						"type": "list",
						"member": {}
					},
					"Limit": {
						"type": "integer"
					},
					"PaginationToken": {},
					"Filter": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Users": {
						"shape": "S9f"
					},
					"PaginationToken": {}
				}
			}
		},
		"ListUsersInGroup": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"GroupName"
				],
				"members": {
					"UserPoolId": {},
					"GroupName": {},
					"Limit": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Users": {
						"shape": "S9f"
					},
					"NextToken": {}
				}
			}
		},
		"ResendConfirmationCode": {
			"input": {
				"type": "structure",
				"required": [
					"ClientId",
					"Username"
				],
				"members": {
					"ClientId": {
						"shape": "S1i"
					},
					"SecretHash": {
						"shape": "S3p"
					},
					"UserContextData": {
						"shape": "S3r"
					},
					"Username": {
						"shape": "Sd"
					},
					"AnalyticsMetadata": {
						"shape": "S1m"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"CodeDeliveryDetails": {
						"shape": "S7q"
					}
				}
			},
			"authtype": "none"
		},
		"RespondToAuthChallenge": {
			"input": {
				"type": "structure",
				"required": [
					"ClientId",
					"ChallengeName"
				],
				"members": {
					"ClientId": {
						"shape": "S1i"
					},
					"ChallengeName": {},
					"Session": {},
					"ChallengeResponses": {
						"shape": "S2x"
					},
					"AnalyticsMetadata": {
						"shape": "S1m"
					},
					"UserContextData": {
						"shape": "S3r"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ChallengeName": {},
					"Session": {},
					"ChallengeParameters": {
						"shape": "S1t"
					},
					"AuthenticationResult": {
						"shape": "S1u"
					}
				}
			}
		},
		"SetRiskConfiguration": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId"
				],
				"members": {
					"UserPoolId": {},
					"ClientId": {
						"shape": "S1i"
					},
					"CompromisedCredentialsRiskConfiguration": {
						"shape": "S6t"
					},
					"AccountTakeoverRiskConfiguration": {
						"shape": "S6y"
					},
					"RiskExceptionConfiguration": {
						"shape": "S77"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"RiskConfiguration"
				],
				"members": {
					"RiskConfiguration": {
						"shape": "S6s"
					}
				}
			}
		},
		"SetUICustomization": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId"
				],
				"members": {
					"UserPoolId": {},
					"ClientId": {
						"shape": "S1i"
					},
					"CSS": {},
					"ImageFile": {
						"type": "blob"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"UICustomization"
				],
				"members": {
					"UICustomization": {
						"shape": "S84"
					}
				}
			}
		},
		"SetUserMFAPreference": {
			"input": {
				"type": "structure",
				"required": [
					"AccessToken"
				],
				"members": {
					"SMSMfaSettings": {
						"shape": "S30"
					},
					"SoftwareTokenMfaSettings": {
						"shape": "S31"
					},
					"AccessToken": {
						"shape": "S1v"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"SetUserPoolMfaConfig": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId"
				],
				"members": {
					"UserPoolId": {},
					"SmsMfaConfiguration": {
						"shape": "S8e"
					},
					"SoftwareTokenMfaConfiguration": {
						"shape": "S8f"
					},
					"MfaConfiguration": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"SmsMfaConfiguration": {
						"shape": "S8e"
					},
					"SoftwareTokenMfaConfiguration": {
						"shape": "S8f"
					},
					"MfaConfiguration": {}
				}
			}
		},
		"SetUserSettings": {
			"input": {
				"type": "structure",
				"required": [
					"AccessToken",
					"MFAOptions"
				],
				"members": {
					"AccessToken": {
						"shape": "S1v"
					},
					"MFAOptions": {
						"shape": "Sv"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			},
			"authtype": "none"
		},
		"SignUp": {
			"input": {
				"type": "structure",
				"required": [
					"ClientId",
					"Username",
					"Password"
				],
				"members": {
					"ClientId": {
						"shape": "S1i"
					},
					"SecretHash": {
						"shape": "S3p"
					},
					"Username": {
						"shape": "Sd"
					},
					"Password": {
						"shape": "Sm"
					},
					"UserAttributes": {
						"shape": "Si"
					},
					"ValidationData": {
						"shape": "Si"
					},
					"AnalyticsMetadata": {
						"shape": "S1m"
					},
					"UserContextData": {
						"shape": "S3r"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"UserConfirmed",
					"UserSub"
				],
				"members": {
					"UserConfirmed": {
						"type": "boolean"
					},
					"CodeDeliveryDetails": {
						"shape": "S7q"
					},
					"UserSub": {}
				}
			},
			"authtype": "none"
		},
		"StartUserImportJob": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"JobId"
				],
				"members": {
					"UserPoolId": {},
					"JobId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"UserImportJob": {
						"shape": "S4j"
					}
				}
			}
		},
		"StopUserImportJob": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"JobId"
				],
				"members": {
					"UserPoolId": {},
					"JobId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"UserImportJob": {
						"shape": "S4j"
					}
				}
			}
		},
		"UpdateAuthEventFeedback": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Username",
					"EventId",
					"FeedbackToken",
					"FeedbackValue"
				],
				"members": {
					"UserPoolId": {},
					"Username": {
						"shape": "Sd"
					},
					"EventId": {},
					"FeedbackToken": {
						"shape": "S1v"
					},
					"FeedbackValue": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"UpdateDeviceStatus": {
			"input": {
				"type": "structure",
				"required": [
					"AccessToken",
					"DeviceKey"
				],
				"members": {
					"AccessToken": {
						"shape": "S1v"
					},
					"DeviceKey": {},
					"DeviceRememberedStatus": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"UpdateGroup": {
			"input": {
				"type": "structure",
				"required": [
					"GroupName",
					"UserPoolId"
				],
				"members": {
					"GroupName": {},
					"UserPoolId": {},
					"Description": {},
					"RoleArn": {},
					"Precedence": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Group": {
						"shape": "S29"
					}
				}
			}
		},
		"UpdateIdentityProvider": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"ProviderName"
				],
				"members": {
					"UserPoolId": {},
					"ProviderName": {},
					"ProviderDetails": {
						"shape": "S40"
					},
					"AttributeMapping": {
						"shape": "S41"
					},
					"IdpIdentifiers": {
						"shape": "S43"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"IdentityProvider"
				],
				"members": {
					"IdentityProvider": {
						"shape": "S46"
					}
				}
			}
		},
		"UpdateResourceServer": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Identifier",
					"Name"
				],
				"members": {
					"UserPoolId": {},
					"Identifier": {},
					"Name": {},
					"Scopes": {
						"shape": "S4a"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"ResourceServer"
				],
				"members": {
					"ResourceServer": {
						"shape": "S4f"
					}
				}
			}
		},
		"UpdateUserAttributes": {
			"input": {
				"type": "structure",
				"required": [
					"UserAttributes",
					"AccessToken"
				],
				"members": {
					"UserAttributes": {
						"shape": "Si"
					},
					"AccessToken": {
						"shape": "S1v"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"CodeDeliveryDetailsList": {
						"type": "list",
						"member": {
							"shape": "S7q"
						}
					}
				}
			},
			"authtype": "none"
		},
		"UpdateUserPool": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId"
				],
				"members": {
					"UserPoolId": {},
					"Policies": {
						"shape": "S4r"
					},
					"LambdaConfig": {
						"shape": "S4u"
					},
					"AutoVerifiedAttributes": {
						"shape": "S4v"
					},
					"SmsVerificationMessage": {},
					"EmailVerificationMessage": {},
					"EmailVerificationSubject": {},
					"VerificationMessageTemplate": {
						"shape": "S54"
					},
					"SmsAuthenticationMessage": {},
					"MfaConfiguration": {},
					"DeviceConfiguration": {
						"shape": "S59"
					},
					"EmailConfiguration": {
						"shape": "S5a"
					},
					"SmsConfiguration": {
						"shape": "S5c"
					},
					"UserPoolTags": {
						"shape": "S5d"
					},
					"AdminCreateUserConfig": {
						"shape": "S5e"
					},
					"UserPoolAddOns": {
						"shape": "S5i"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"UpdateUserPoolClient": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"ClientId"
				],
				"members": {
					"UserPoolId": {},
					"ClientId": {
						"shape": "S1i"
					},
					"ClientName": {},
					"RefreshTokenValidity": {
						"type": "integer"
					},
					"ReadAttributes": {
						"shape": "S5s"
					},
					"WriteAttributes": {
						"shape": "S5s"
					},
					"ExplicitAuthFlows": {
						"shape": "S5u"
					},
					"SupportedIdentityProviders": {
						"shape": "S5w"
					},
					"CallbackURLs": {
						"shape": "S5x"
					},
					"LogoutURLs": {
						"shape": "S5z"
					},
					"DefaultRedirectURI": {},
					"AllowedOAuthFlows": {
						"shape": "S60"
					},
					"AllowedOAuthScopes": {
						"shape": "S62"
					},
					"AllowedOAuthFlowsUserPoolClient": {
						"type": "boolean"
					},
					"AnalyticsConfiguration": {
						"shape": "S64"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"UserPoolClient": {
						"shape": "S67"
					}
				}
			}
		},
		"UpdateUserPoolDomain": {
			"input": {
				"type": "structure",
				"required": [
					"Domain",
					"UserPoolId",
					"CustomDomainConfig"
				],
				"members": {
					"Domain": {},
					"UserPoolId": {},
					"CustomDomainConfig": {
						"shape": "S6a"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"CloudFrontDomain": {}
				}
			}
		},
		"VerifySoftwareToken": {
			"input": {
				"type": "structure",
				"required": [
					"UserCode"
				],
				"members": {
					"AccessToken": {
						"shape": "S1v"
					},
					"Session": {},
					"UserCode": {},
					"FriendlyDeviceName": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Status": {},
					"Session": {}
				}
			}
		},
		"VerifyUserAttribute": {
			"input": {
				"type": "structure",
				"required": [
					"AccessToken",
					"AttributeName",
					"Code"
				],
				"members": {
					"AccessToken": {
						"shape": "S1v"
					},
					"AttributeName": {},
					"Code": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			},
			"authtype": "none"
		}
	},
	"shapes": {
		"S4": {
			"type": "structure",
			"members": {
				"Name": {},
				"AttributeDataType": {},
				"DeveloperOnlyAttribute": {
					"type": "boolean"
				},
				"Mutable": {
					"type": "boolean"
				},
				"Required": {
					"type": "boolean"
				},
				"NumberAttributeConstraints": {
					"type": "structure",
					"members": {
						"MinValue": {},
						"MaxValue": {}
					}
				},
				"StringAttributeConstraints": {
					"type": "structure",
					"members": {
						"MinLength": {},
						"MaxLength": {}
					}
				}
			}
		},
		"Sd": {
			"type": "string",
			"sensitive": true
		},
		"Si": {
			"type": "list",
			"member": {
				"type": "structure",
				"required": [
					"Name"
				],
				"members": {
					"Name": {},
					"Value": {
						"type": "string",
						"sensitive": true
					}
				}
			}
		},
		"Sm": {
			"type": "string",
			"sensitive": true
		},
		"Ss": {
			"type": "structure",
			"members": {
				"Username": {
					"shape": "Sd"
				},
				"Attributes": {
					"shape": "Si"
				},
				"UserCreateDate": {
					"type": "timestamp"
				},
				"UserLastModifiedDate": {
					"type": "timestamp"
				},
				"Enabled": {
					"type": "boolean"
				},
				"UserStatus": {},
				"MFAOptions": {
					"shape": "Sv"
				}
			}
		},
		"Sv": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"DeliveryMedium": {},
					"AttributeName": {}
				}
			}
		},
		"Sz": {
			"type": "list",
			"member": {}
		},
		"S12": {
			"type": "structure",
			"members": {
				"ProviderName": {},
				"ProviderAttributeName": {},
				"ProviderAttributeValue": {}
			}
		},
		"S1d": {
			"type": "structure",
			"members": {
				"DeviceKey": {},
				"DeviceAttributes": {
					"shape": "Si"
				},
				"DeviceCreateDate": {
					"type": "timestamp"
				},
				"DeviceLastModifiedDate": {
					"type": "timestamp"
				},
				"DeviceLastAuthenticatedDate": {
					"type": "timestamp"
				}
			}
		},
		"S1g": {
			"type": "list",
			"member": {}
		},
		"S1i": {
			"type": "string",
			"sensitive": true
		},
		"S1k": {
			"type": "map",
			"key": {},
			"value": {}
		},
		"S1l": {
			"type": "map",
			"key": {},
			"value": {}
		},
		"S1m": {
			"type": "structure",
			"members": {
				"AnalyticsEndpointId": {}
			}
		},
		"S1n": {
			"type": "structure",
			"required": [
				"IpAddress",
				"ServerName",
				"ServerPath",
				"HttpHeaders"
			],
			"members": {
				"IpAddress": {},
				"ServerName": {},
				"ServerPath": {},
				"HttpHeaders": {
					"type": "list",
					"member": {
						"type": "structure",
						"members": {
							"headerName": {},
							"headerValue": {}
						}
					}
				},
				"EncodedData": {}
			}
		},
		"S1t": {
			"type": "map",
			"key": {},
			"value": {}
		},
		"S1u": {
			"type": "structure",
			"members": {
				"AccessToken": {
					"shape": "S1v"
				},
				"ExpiresIn": {
					"type": "integer"
				},
				"TokenType": {},
				"RefreshToken": {
					"shape": "S1v"
				},
				"IdToken": {
					"shape": "S1v"
				},
				"NewDeviceMetadata": {
					"type": "structure",
					"members": {
						"DeviceKey": {},
						"DeviceGroupKey": {}
					}
				}
			}
		},
		"S1v": {
			"type": "string",
			"sensitive": true
		},
		"S24": {
			"type": "list",
			"member": {
				"shape": "S1d"
			}
		},
		"S28": {
			"type": "list",
			"member": {
				"shape": "S29"
			}
		},
		"S29": {
			"type": "structure",
			"members": {
				"GroupName": {},
				"UserPoolId": {},
				"Description": {},
				"RoleArn": {},
				"Precedence": {
					"type": "integer"
				},
				"LastModifiedDate": {
					"type": "timestamp"
				},
				"CreationDate": {
					"type": "timestamp"
				}
			}
		},
		"S2x": {
			"type": "map",
			"key": {},
			"value": {}
		},
		"S30": {
			"type": "structure",
			"members": {
				"Enabled": {
					"type": "boolean"
				},
				"PreferredMfa": {
					"type": "boolean"
				}
			}
		},
		"S31": {
			"type": "structure",
			"members": {
				"Enabled": {
					"type": "boolean"
				},
				"PreferredMfa": {
					"type": "boolean"
				}
			}
		},
		"S3p": {
			"type": "string",
			"sensitive": true
		},
		"S3r": {
			"type": "structure",
			"members": {
				"EncodedData": {}
			}
		},
		"S40": {
			"type": "map",
			"key": {},
			"value": {}
		},
		"S41": {
			"type": "map",
			"key": {},
			"value": {}
		},
		"S43": {
			"type": "list",
			"member": {}
		},
		"S46": {
			"type": "structure",
			"members": {
				"UserPoolId": {},
				"ProviderName": {},
				"ProviderType": {},
				"ProviderDetails": {
					"shape": "S40"
				},
				"AttributeMapping": {
					"shape": "S41"
				},
				"IdpIdentifiers": {
					"shape": "S43"
				},
				"LastModifiedDate": {
					"type": "timestamp"
				},
				"CreationDate": {
					"type": "timestamp"
				}
			}
		},
		"S4a": {
			"type": "list",
			"member": {
				"type": "structure",
				"required": [
					"ScopeName",
					"ScopeDescription"
				],
				"members": {
					"ScopeName": {},
					"ScopeDescription": {}
				}
			}
		},
		"S4f": {
			"type": "structure",
			"members": {
				"UserPoolId": {},
				"Identifier": {},
				"Name": {},
				"Scopes": {
					"shape": "S4a"
				}
			}
		},
		"S4j": {
			"type": "structure",
			"members": {
				"JobName": {},
				"JobId": {},
				"UserPoolId": {},
				"PreSignedUrl": {},
				"CreationDate": {
					"type": "timestamp"
				},
				"StartDate": {
					"type": "timestamp"
				},
				"CompletionDate": {
					"type": "timestamp"
				},
				"Status": {},
				"CloudWatchLogsRoleArn": {},
				"ImportedUsers": {
					"type": "long"
				},
				"SkippedUsers": {
					"type": "long"
				},
				"FailedUsers": {
					"type": "long"
				},
				"CompletionMessage": {}
			}
		},
		"S4r": {
			"type": "structure",
			"members": {
				"PasswordPolicy": {
					"type": "structure",
					"members": {
						"MinimumLength": {
							"type": "integer"
						},
						"RequireUppercase": {
							"type": "boolean"
						},
						"RequireLowercase": {
							"type": "boolean"
						},
						"RequireNumbers": {
							"type": "boolean"
						},
						"RequireSymbols": {
							"type": "boolean"
						}
					}
				}
			}
		},
		"S4u": {
			"type": "structure",
			"members": {
				"PreSignUp": {},
				"CustomMessage": {},
				"PostConfirmation": {},
				"PreAuthentication": {},
				"PostAuthentication": {},
				"DefineAuthChallenge": {},
				"CreateAuthChallenge": {},
				"VerifyAuthChallengeResponse": {},
				"PreTokenGeneration": {},
				"UserMigration": {}
			}
		},
		"S4v": {
			"type": "list",
			"member": {}
		},
		"S4x": {
			"type": "list",
			"member": {}
		},
		"S4z": {
			"type": "list",
			"member": {}
		},
		"S54": {
			"type": "structure",
			"members": {
				"SmsMessage": {},
				"EmailMessage": {},
				"EmailSubject": {},
				"EmailMessageByLink": {},
				"EmailSubjectByLink": {},
				"DefaultEmailOption": {}
			}
		},
		"S59": {
			"type": "structure",
			"members": {
				"ChallengeRequiredOnNewDevice": {
					"type": "boolean"
				},
				"DeviceOnlyRememberedOnUserPrompt": {
					"type": "boolean"
				}
			}
		},
		"S5a": {
			"type": "structure",
			"members": {
				"SourceArn": {},
				"ReplyToEmailAddress": {}
			}
		},
		"S5c": {
			"type": "structure",
			"required": [
				"SnsCallerArn"
			],
			"members": {
				"SnsCallerArn": {},
				"ExternalId": {}
			}
		},
		"S5d": {
			"type": "map",
			"key": {},
			"value": {}
		},
		"S5e": {
			"type": "structure",
			"members": {
				"AllowAdminCreateUserOnly": {
					"type": "boolean"
				},
				"UnusedAccountValidityDays": {
					"type": "integer"
				},
				"InviteMessageTemplate": {
					"type": "structure",
					"members": {
						"SMSMessage": {},
						"EmailMessage": {},
						"EmailSubject": {}
					}
				}
			}
		},
		"S5h": {
			"type": "list",
			"member": {
				"shape": "S4"
			}
		},
		"S5i": {
			"type": "structure",
			"required": [
				"AdvancedSecurityMode"
			],
			"members": {
				"AdvancedSecurityMode": {}
			}
		},
		"S5l": {
			"type": "structure",
			"members": {
				"Id": {},
				"Name": {},
				"Policies": {
					"shape": "S4r"
				},
				"LambdaConfig": {
					"shape": "S4u"
				},
				"Status": {},
				"LastModifiedDate": {
					"type": "timestamp"
				},
				"CreationDate": {
					"type": "timestamp"
				},
				"SchemaAttributes": {
					"shape": "S5h"
				},
				"AutoVerifiedAttributes": {
					"shape": "S4v"
				},
				"AliasAttributes": {
					"shape": "S4x"
				},
				"UsernameAttributes": {
					"shape": "S4z"
				},
				"SmsVerificationMessage": {},
				"EmailVerificationMessage": {},
				"EmailVerificationSubject": {},
				"VerificationMessageTemplate": {
					"shape": "S54"
				},
				"SmsAuthenticationMessage": {},
				"MfaConfiguration": {},
				"DeviceConfiguration": {
					"shape": "S59"
				},
				"EstimatedNumberOfUsers": {
					"type": "integer"
				},
				"EmailConfiguration": {
					"shape": "S5a"
				},
				"SmsConfiguration": {
					"shape": "S5c"
				},
				"UserPoolTags": {
					"shape": "S5d"
				},
				"SmsConfigurationFailure": {},
				"EmailConfigurationFailure": {},
				"Domain": {},
				"CustomDomain": {},
				"AdminCreateUserConfig": {
					"shape": "S5e"
				},
				"UserPoolAddOns": {
					"shape": "S5i"
				},
				"Arn": {}
			}
		},
		"S5s": {
			"type": "list",
			"member": {}
		},
		"S5u": {
			"type": "list",
			"member": {}
		},
		"S5w": {
			"type": "list",
			"member": {}
		},
		"S5x": {
			"type": "list",
			"member": {}
		},
		"S5z": {
			"type": "list",
			"member": {}
		},
		"S60": {
			"type": "list",
			"member": {}
		},
		"S62": {
			"type": "list",
			"member": {}
		},
		"S64": {
			"type": "structure",
			"required": [
				"ApplicationId",
				"RoleArn",
				"ExternalId"
			],
			"members": {
				"ApplicationId": {},
				"RoleArn": {},
				"ExternalId": {},
				"UserDataShared": {
					"type": "boolean"
				}
			}
		},
		"S67": {
			"type": "structure",
			"members": {
				"UserPoolId": {},
				"ClientName": {},
				"ClientId": {
					"shape": "S1i"
				},
				"ClientSecret": {
					"type": "string",
					"sensitive": true
				},
				"LastModifiedDate": {
					"type": "timestamp"
				},
				"CreationDate": {
					"type": "timestamp"
				},
				"RefreshTokenValidity": {
					"type": "integer"
				},
				"ReadAttributes": {
					"shape": "S5s"
				},
				"WriteAttributes": {
					"shape": "S5s"
				},
				"ExplicitAuthFlows": {
					"shape": "S5u"
				},
				"SupportedIdentityProviders": {
					"shape": "S5w"
				},
				"CallbackURLs": {
					"shape": "S5x"
				},
				"LogoutURLs": {
					"shape": "S5z"
				},
				"DefaultRedirectURI": {},
				"AllowedOAuthFlows": {
					"shape": "S60"
				},
				"AllowedOAuthScopes": {
					"shape": "S62"
				},
				"AllowedOAuthFlowsUserPoolClient": {
					"type": "boolean"
				},
				"AnalyticsConfiguration": {
					"shape": "S64"
				}
			}
		},
		"S6a": {
			"type": "structure",
			"required": [
				"CertificateArn"
			],
			"members": {
				"CertificateArn": {}
			}
		},
		"S6s": {
			"type": "structure",
			"members": {
				"UserPoolId": {},
				"ClientId": {
					"shape": "S1i"
				},
				"CompromisedCredentialsRiskConfiguration": {
					"shape": "S6t"
				},
				"AccountTakeoverRiskConfiguration": {
					"shape": "S6y"
				},
				"RiskExceptionConfiguration": {
					"shape": "S77"
				},
				"LastModifiedDate": {
					"type": "timestamp"
				}
			}
		},
		"S6t": {
			"type": "structure",
			"required": [
				"Actions"
			],
			"members": {
				"EventFilter": {
					"type": "list",
					"member": {}
				},
				"Actions": {
					"type": "structure",
					"required": [
						"EventAction"
					],
					"members": {
						"EventAction": {}
					}
				}
			}
		},
		"S6y": {
			"type": "structure",
			"required": [
				"Actions"
			],
			"members": {
				"NotifyConfiguration": {
					"type": "structure",
					"required": [
						"SourceArn"
					],
					"members": {
						"From": {},
						"ReplyTo": {},
						"SourceArn": {},
						"BlockEmail": {
							"shape": "S70"
						},
						"NoActionEmail": {
							"shape": "S70"
						},
						"MfaEmail": {
							"shape": "S70"
						}
					}
				},
				"Actions": {
					"type": "structure",
					"members": {
						"LowAction": {
							"shape": "S74"
						},
						"MediumAction": {
							"shape": "S74"
						},
						"HighAction": {
							"shape": "S74"
						}
					}
				}
			}
		},
		"S70": {
			"type": "structure",
			"required": [
				"Subject"
			],
			"members": {
				"Subject": {},
				"HtmlBody": {},
				"TextBody": {}
			}
		},
		"S74": {
			"type": "structure",
			"required": [
				"Notify",
				"EventAction"
			],
			"members": {
				"Notify": {
					"type": "boolean"
				},
				"EventAction": {}
			}
		},
		"S77": {
			"type": "structure",
			"members": {
				"BlockedIPRangeList": {
					"type": "list",
					"member": {}
				},
				"SkippedIPRangeList": {
					"type": "list",
					"member": {}
				}
			}
		},
		"S7q": {
			"type": "structure",
			"members": {
				"Destination": {},
				"DeliveryMedium": {},
				"AttributeName": {}
			}
		},
		"S84": {
			"type": "structure",
			"members": {
				"UserPoolId": {},
				"ClientId": {
					"shape": "S1i"
				},
				"ImageUrl": {},
				"CSS": {},
				"CSSVersion": {},
				"LastModifiedDate": {
					"type": "timestamp"
				},
				"CreationDate": {
					"type": "timestamp"
				}
			}
		},
		"S8e": {
			"type": "structure",
			"members": {
				"SmsAuthenticationMessage": {},
				"SmsConfiguration": {
					"shape": "S5c"
				}
			}
		},
		"S8f": {
			"type": "structure",
			"members": {
				"Enabled": {
					"type": "boolean"
				}
			}
		},
		"S9f": {
			"type": "list",
			"member": {
				"shape": "Ss"
			}
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/cognito-idp-2016-04-18.min.json
// module id = 419
// module chunks = 0